module.exports = __webpack_public_path__ + "img/share_top2_bg.b46264bd.webp";